import React, { useMemo } from 'react';
import {
  Button,
  Flex,
  Stack,
  Text,
  useBreakpointValue
} from '@chakra-ui/react';
import { FaDownload } from 'react-icons/fa';
import { pdfjs } from 'react-pdf';
import { useNavigate } from 'react-router-dom';
import PageLayout from './PageLayout';
import PdfOcrViewer from './PdfOcrViewer';

const pdfFile = '04 - LIVRETO REGIMENTO INTERNO LMEC - MIOLO - FINAL.pdf';

const buildPdfUrl = (filename) => {
  const prefix = process.env.PUBLIC_URL || '';
  return encodeURI(`${prefix}/${filename}`);
};

pdfjs.GlobalWorkerOptions.workerSrc = buildPdfUrl('pdf.worker.min.js');

const RegimentoInternoPage = () => {
  const navigate = useNavigate();
  const viewerHeight = useBreakpointValue({ base: '56vh', md: '82vh' });
  const viewerWidth = useBreakpointValue({ base: undefined, md: 960 });
  const pdfUrl = useMemo(() => buildPdfUrl(pdfFile), []);

  return (
    <PageLayout
      title="Regimento Interno"
      subtitle="Miolo"
      onBack={() => navigate('/')}
      accent="#C9A24C"
      background="#EEF3F7"
      watermark="/maconaria.png"
    >
      <Stack spacing={4}>
        <Flex align="center" justify="space-between" flexWrap="wrap" gap={3}>
          <Text fontSize={{ base: 'xs', md: 'sm' }} color="gray.600">
            Leitura continua com rolagem pelo documento inteiro.
          </Text>
          <Button
            leftIcon={<FaDownload />}
            as="a"
            href={pdfUrl}
            target="_blank"
            rel="noreferrer"
            colorScheme="blue"
            size="sm"
          >
            Baixar
          </Button>
        </Flex>

        <PdfOcrViewer
          pdfUrl={pdfUrl}
          pageNumber={1}
          onDocumentLoad={() => {}}
          viewerWidth={viewerWidth || 720}
          viewerHeight={viewerHeight || '600px'}
          storageKey="regimento-interno"
          annotationMode
          continuousMode
        />
      </Stack>
    </PageLayout>
  );
};

export default RegimentoInternoPage;
